import { Reducer } from "redux";

import { UserDetailsInAdminActionDispatchTypes } from "../constants/User";
import { UserDetailsInAdminResponse } from "../models/api/User";
import { UserDetailsInAdminActionTypes } from "../models/dispatchTypes/User";

export const initialState: UserDetailsInAdminResponse = {
  loading: false,
  response: {
    providerPortalUser: {
      userId: "",
      userName: "",
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      status: "",
      twoFactorEnabled: true,
      accessFailedCount: true,
      registrationDate: "",
      registrationSource: "",
      approver: null,
      mfaId: 0,
      mfaType: "",
      roleId: "",
      roleType: "",
      userCreated: "",
    },
    userProviderList: [],
  },
    error: null,
};

const AdminSelectedUserDetailsReducer: Reducer<UserDetailsInAdminResponse, UserDetailsInAdminActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_LOADING: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
        error: null
      };
    }
    case UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    case UserDetailsInAdminActionDispatchTypes.USER_DEATILS_IN_ADMIN_RESET: {
      return initialState;
    }
  }
  return state;
};

export default AdminSelectedUserDetailsReducer;
